module.exports = __webpack_public_path__ + "media/images/icon_ok-050759fba681776f503498cdc32f8246.svg";